export default "__VITE_ASSET__Dvy8fvdk__"